export default "__VITE_ASSET__CF7IpOUp__$_?url__"